// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateNft_container__kBgQb","textSide":"CreateNft_textSide__uzqTS","deployButton":"CreateNft_deployButton__Z8qGG"};